interface Level3TitleProps {
    title: string;
}

const Level3Title = ({title}: Level3TitleProps): JSX.Element => {
    return <h3 className={'fs-3 fw-semibold'}>{title}</h3>;
};

export default Level3Title;
